<template>
  <IconDavinciResolve
    v-if="davinciResolve"
  />

  <IconFinalCutPro
    v-else-if="finalCutPro"
  />

  <IconRoyaltyFreeMusic
    v-else-if="royaltyFreeMusic"
  />

  <IconSoundEffects
    v-else-if="soundEffects"
  />

  <IconStockVideo
    v-else-if="stockVideo"
  />

  <IconStockMotionGraphics
    v-else-if="motionGraphics"
  />

  <IconIntegrations
    v-else-if="integrations"
  />

  <IconGraphics
    v-else-if="graphics"
  />

  <IconPhotos
    v-else-if="stockPhotos"
  />

  <IconMarketplace v-else />
</template>

<script>
import IconDavinciResolve from './icons/icon-davinci-resolve.vue';
import IconFinalCutPro from './icons/icon-final-cut-pro.vue';
import IconRoyaltyFreeMusic from './icons/icon-royalty-free-music.vue';
import IconSoundEffects from './icons/icon-sound-effects.vue';
import IconStockVideo from './icons/icon-stock-video.vue';
import IconStockMotionGraphics from './icons/icon-stock-motion-graphics.vue';
import IconIntegrations from './icons/icon-integrations.vue';
import IconGraphics from './icons/icon-graphics.vue';
import IconPhotos from './icons/icon-photos.vue';
import IconMarketplace from './icons/icon-marketplace.vue';

export default {
  components: {
    IconDavinciResolve,
    IconFinalCutPro,
    IconRoyaltyFreeMusic,
    IconSoundEffects,
    IconStockVideo,
    IconStockMotionGraphics,
    IconIntegrations,
    IconGraphics,
    IconPhotos,
    IconMarketplace,
  },

  props: {
    link: {
      required: true,
      type: String,
    },
  },

  computed: {
    davinciResolve() {
      return this.link.startsWith('/browse/davinci-resolve');
    },

    finalCutPro() {
      return this.link.startsWith('/browse/final-cut-pro-templates');
    },

    royaltyFreeMusic() {
      return this.link.startsWith('/browse/royalty-free-music');
    },

    soundEffects() {
      return this.link.startsWith('/browse/sound-effects');
    },

    stockVideo() {
      return this.link.startsWith('/browse/stock-video');
    },

    motionGraphics() {
      return this.link.startsWith('/browse/stock-motion-graphics');
    },

    stockPhotos() {
      return this.link.startsWith('/browse/stock-photos');
    },

    graphics() {
      return this.link.startsWith('/browse/graphics');
    },

    integrations() {
      return this.link.startsWith('/integrations');
    },
  },
};
</script>
